<template>
  <div id="MonthReport">
    <div class="data_head">
      <span class="text_panel">参数</span>
      <!--            <el-col :span="6">-->
      <el-cascader
        ref="cascaderAddr"
        v-model="value"
        :options="paramOptions"
        :props="{
          value: 'code',
          label: 'name',
          children: 'childHashSet',
          multiple: true,
        }"
        :show-all-levels="false"
        @change="changeLabel"
        collapse-tags
        clearable
      ></el-cascader>
      <!--            </el-col>-->
      <el-date-picker
        v-model="searchDate"
        align="right"
        type="month"
        value-format="yyyy"
        :editable="false"
      >
      </el-date-picker>
      <el-button type="primary" @click="search()" class="searchButton"
      >查&nbsp;询</el-button
      >
      <el-button type="primary" class="searchButton" @click="download()"
      >下载</el-button
      >
    </div>

    <div class="table tableContent" style="height: 625px" id="table">
      <el-scrollbar style="height: 100%">
        <el-table
          id="exportTab"
          :data="list"
          style="width: 100%"
          :header-cell-style="{ background: '#335ABB', color: '#FFF' }"
          :row-style="{ height: '36px' }"
          stripe
        >
          <el-table-column :label="tableTitle" align="center">
            <el-table-column
              prop="dataTime"
              label="时间"
              align="center"
            ></el-table-column>
            <!-- v-if="projectName!=='内部深层位移'&&projectName!=='内部位移'&&projectName!==''" -->
            <el-table-column
              prop="measureNo"
              v-if="
                projectName !== '内部深层位移' &&
                projectName !== '内部位移' &&
                projectName !== ''
              "
              label="传感器编号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="measureNo"
              v-if="
                (projectName == '内部深层位移' && projectName !== '') ||
                (projectName == '内部位移' && projectName !== '')
              "
              label="测孔编号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="totalOffset"
              label="累计位移量（mm）"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="thisChange"
              label="本次变化（mm）"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="thisChange"
              label="变化速率（mm/d）"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="continuitySpeed"
              label="连续3天变化速率（mm/d）"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="mark"
              label="备注"
              align="center"
            ></el-table-column>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
    import Vue from "vue";
    import * as FileSaver from "file-saver";
    import * as XLSX from "xlsx";

    Vue.filter("rounding", function (value) {
        if (!value) return "--";
        return parseFloat(value).toFixed(4);
    });
    export default {
        name: "YearReport",
        data() {
            return {
                measureNos: [],
                paramOptions: [],
                list: [],
                searchDate: "",
                tableTitle: "年报表", //日报表展示头部文字
                projectName: "", //下拉一级菜单名字
                navName: "", //首页选择八亩塘还是佛顶山

                value: [], //下拉选中的数据
                shareScopeEnd: [], //下拉结束时选中的 数据
                selectList: [], //查询选中的测点编号
            };
        },
        created(){
            this.showMonth();
        },

        mounted: function () {
            this.$axios.get("/api/monitor/dataHistory/getMeasureByCode").then((res) => {
                // this.paramOptions = res.data.datas.values;
                let newArr = res.data.datas.values;
                for (let i = 0; i < newArr.length; i++) {
                    if (newArr[i].name == "内部深层位移" || newArr[i].name == "内部位移") {
                        // console.log(newArr[i],22)
                        for (let j = 0; j < newArr[i].childHashSet.length; j++) {
                            newArr[i].childHashSet[j].childHashSet = null;
                        }
                    }
                }
                this.paramOptions = newArr;
            });

            if (localStorage.getItem("mainId") == 24) {
                this.navName = "佛顶寺";
            }
            if (localStorage.getItem("mainId") == 25) {
                this.navName = "八亩唐";
            }
        },
        methods: {
            showMonth() {
                let date = new Date();
                let year = date.getFullYear();
                this.searchDate = year
            },
            //下拉改变
            changeLabel(val) {
                if (val.length !== 0) {
                    this.projectName =
                        this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels[0];
                }
                let changeFlag = false;
                let changeItem = null;
                if (this.shareScopeEnd.length == 0) {
                    this.value = val;
                } else {
                    // 与原数组比对
                    this.value.forEach((item) => {
                        if (item[0] !== this.shareScopeEnd[0][0]) {
                            // 一级标签不同、一级菜单单选
                            changeFlag = true;
                            changeItem = item;
                        } else if (item[1] != this.shareScopeEnd[0][1]) {
                            // （一级标签相同）但是二级标签不同，二级菜单单选
                            changeFlag = true;
                            changeItem = item;
                        } else if (
                            (!item[2] && this.shareScopeEnd[0][2]) ||
                            (item[2] && !this.shareScopeEnd[0][2])
                        ) {
                            changeFlag = true;
                            changeItem = item;
                        }
                    });
                }
                if (changeFlag) {
                    this.value = [];
                    this.value.push(changeItem);
                }
                this.shareScopeEnd = this.value;
                this.selectList = [];
                this.shareScopeEnd.forEach((item) => {
                    if (item.length === 3) {
                        this.selectList.push(item[2]);
                    } else if (item.length === 2) {
                        this.selectList.push(item[1]);
                    } else {
                        this.selectList = [];
                    }
                });
                //   console.log(this.selectList,333)
            },
            search() {
                if (this.selectList.length === 0) {
                    this.$message({
                        type: "error",
                        message: "请选择编号",
                    });
                }
                this.searchDate =
                    this.searchDate.split("-")[0] + "-" + this.searchDate.split("-")[1];
                this.tableTitle =
                    "(" +
                    this.navName +
                    ")" +
                    this.projectName +
                    "年报表";
                if (this.projectName == "三向位移") {
                    this.$axios
                        .get(
                            `/api/monitor/report/getReport?code=${this.selectList}
                &time=${this.searchDate}&type=2`
                        )
                        .then((res) => {
                            this.list = res.data.datas.values;
                        });
                } else if (this.projectName == "内部深层位移") {
                    this.$axios
                        .get(
                            `/api/monitor/report/getReport?code=${this.selectList}&time=${this.searchDate}
                &type=2&parentCode=${this.selectList}`
                        )
                        .then((res) => {
                            this.list = res.data.datas.values;
                        });
                } else if (this.projectName == "内部位移") {
                    this.$axios
                        .get(
                            `/api/monitor/report/getReport?code=${this.selectList}&time=${this.searchDate}
                &type=2&parentCode=${this.selectList}`
                        )
                        .then((res) => {
                            this.list = res.data.datas.values;
                        });
                } else {
                    this.$axios
                        .get(
                            `/api/monitor/report/getReport?code=${this.selectList}&time=${this.searchDate}&type=2`
                        )
                        .then((res) => {
                            this.list = res.data.datas.values;
                        });
                }
            },
            download() {
                this.exportExcel();
            },
            exportExcel() {
                this.$nextTick(function () {
                    var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换
                    var wb = XLSX.utils.table_to_book(
                        document.querySelector("#exportTab"),
                        xlsxParam
                    );
                    var wbout = XLSX.write(wb, {
                        bookType: "xlsx",
                        bookSST: true,
                        type: "array",
                    });
                    try {
                        FileSaver.saveAs(
                            new Blob([wbout], { type: "application/octet-stream" }),
                            this.tableTitle + ".xlsx"
                        );
                    } catch (e) {
                        if (typeof console !== "undefined") {
                            // console.log(e, wbout)
                        }
                    }
                    return wbout;
                });
            },
        },
    };
</script>

<style>
  #table .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  #MonthReport .el-cascader .el-input .el-input__inner {
    color: #fff;
    background-color: #3457de;
  }

  #MonthReport .el-date-editor .el-input__inner {
    background-color: #3457de;
    color: #fff;
  }

  #MonthReport .el-table {
    color: #a7ccf6;
  }

  #MonthReport .el-table__row {
    background-color: #0b3a68 !important;
  }

  #MonthReport .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #021535;
  }

  #MonthReport .el-table td {
    border: unset;
  }

  #MonthReport .el-table th.is-leaf {
    border-bottom: none;
  }

  #MonthReport .el-date-editor--daterange.el-input__inner {
    background-color: #3457de;
  }

  #MonthReport .el-date-editor .el-range-input {
    background-color: #3457de;
    color: #fff;
  }

  #MonthReport .el-date-editor .el-range-separator {
    background-color: unset;
    color: #fff;
  }
</style>

<style scoped>
  @import url("../../assets/css/style.css");
</style>




// WEBPACK FOOTER //
// src/components/reportManage/YearReport.vue